export enum FeatureFlags {
  CALENDAR = 'CALENDAR',
  SCENARIO = 'SCENARIO',
  LIGHT_THEME = 'LIGHT_THEME',
}

export interface Flags {
  [key: string]: boolean | undefined;
}

export type FeatureFlagsKeys = keyof Flags;
